module.exports = __webpack_public_path__ + "media/legacy/components/MainSection/iphone-video-fb0e62ec32d349147340143897f34a18.mp4";